export default "__VITE_ASSET__D3py8ZFl__"